<div class="dropdown-panel absolute right-0 mt-2 pt-2 w-[311px] bg-white shadow-xl z-[10] rounded-b-[4px]">
    <div class="flex flex-col bg-emerald-500 p-[20px] rounded-t-[4px]">
        <!--TODO: This username will be fetched from the database, including the name and department -->
        <span class="text-white font-bold heading-16">{{ user.username }}</span>
        <span class="text-white text-[10px]">{{ user.emailAddress }}</span>
    </div>
    <ul>
        @for (item of dropdownItems; track item) {
        <li class="flex gap-x-[16px] p-[20px] heading-14 hover:bg-gray-100 hover:cursor-pointer">
            @if(item.iconName) {
            <ng-container appDynamicIcon [iconName]="item.iconName"></ng-container>
            }
            @if(item.link) {
            <a [href]="item.link" class="text-gray-800">{{ item.name }}</a>
            }

            @if(item.action) {
            <button (click)="item.action()" class="text-left w-full last:text-red-500">{{ item.name }}</button>
            }
        </li>
        }
    </ul>
</div>